//RadarData.js



//DataSet class
//------------------------------------------------------------------------
class DataSet {
	constructor( label, borderColor, data){

		this.label = label;
		this.backgroundColor = "transparent"
		this.borderColor = borderColor;
		this.borderWidth = 2; 
		this.pointRadius = 0; 
		this.data = data;
	}
}


//Color array for variants of radar chart
var colors = [
		'rgba(109, 66,  153, 0.4)',      //Variant 1 -> 
		'rgba(50,  93,  186, 0.4)',      //Variant 2 -> 
		'rgba(112, 186, 204, 0.4)',      //Variant 3 -> 
		'rgba(191, 67,  42,  0.4)',      //Variant 4 -> 
		'rgba(227, 160, 45,  0.4)',      //Variant 5 -> 
		'rgba(255, 221, 84,  0.4)',      //Variant 6 -> 
		'rgba(56,  105, 89,  0.4)',      //Variant 7 -> 
		'rgba(114, 173, 140, 0.4)',      //Variant 8 ->         
]

//Color array for variants of radar chart
var transparentColors = [
	'rgba(109, 66,  153, 0.2)',      //Variant 1 -> 
	'rgba(50,  93,  186, 0.2)',      //Variant 2 -> 
	'rgba(112, 186, 204, 0.2)',      //Variant 3 -> 
	'rgba(191, 67,  42,  0.2)',      //Variant 4 -> 
	'rgba(227, 160, 45,  0.2)',      //Variant 5 -> 
	'rgba(255, 221, 84,  0.2)',      //Variant 6 -> 
	'rgba(56,  105, 89,  0.2)',      //Variant 7 -> 
	'rgba(114, 173, 140, 0.2)',      //Variant 8 ->         
]


//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------

export {DataSet, colors, transparentColors }
